import request from '@/config/request.js'
import setting from '@/config/settings'
import common from '@/components/common/'

const ApiStudentManagement = request.StudentManagement
const ApiClassManagement = request.ClassManagement

const STORAGE_KEY = 'bell_education_pet_score_state'
const QINIU_BASE_URL = setting && setting.gbs && setting.gbs.qiniu
  ? String(setting.gbs.qiniu)
  : ''

const ACTION_LIST = [
  { code: 'ATTEND_ON_TIME', name: '准时考勤', points: 5, category: '秩序', applyMode: '全班/单人', standard: '按时到校并完成签到' },
  { code: 'LINE_UP', name: '路队整齐', points: 5, category: '秩序', applyMode: '全班/单人', standard: '不推挤、不掉队、听指令' },
  { code: 'WASH_HANDS', name: '饭前洗手', points: 5, category: '生活', applyMode: '全班/单人', standard: '主动洗手、排队有序' },
  { code: 'CLEAN_PLATE', name: '光盘行动', points: 5, category: '生活', applyMode: '单人/多人', standard: '吃完合理饭量、不浪费' },
  { code: 'QUIET_NAP', name: '午休安静', points: 5, category: '生活', applyMode: '单人/多人', standard: '按时入睡、不影响他人' },
  { code: 'PUT_BACK', name: '物品归位', points: 5, category: '自理', applyMode: '单人/多人', standard: '餐具、书包、文具主动整理' },
  { code: 'DO_HOUSEWORK', name: '主动做家务', points: 5, category: '自理', applyMode: '单人/多人', standard: '擦桌、摆餐具、整理公共区域' },
  { code: 'POLITE', name: '文明有礼', points: 5, category: '品德', applyMode: '单人', standard: '主动问好、道谢、礼貌表达' },
  { code: 'HELPFUL', name: '主动帮助', points: 10, category: '品德', applyMode: '单人', standard: '主动帮助同学或老师' },
  { code: 'HOMEWORK_READY', name: '作业准备快', points: 5, category: '学习', applyMode: '单人/多人', standard: '到位后快速拿出用品进入状态' },
  { code: 'HOMEWORK_GOOD', name: '作业效率高', points: 10, category: '学习', applyMode: '单人/多人', standard: '在合理时间内认真完成并检查' },
  { code: 'BIG_PROGRESS', name: '今日大进步', points: 15, category: '综合', applyMode: '单人', standard: '整体表现非常出色' }
]

/**
 * 将接口返回的图片路径补齐为可直接展示的七牛地址。
 * @param {string} imagePath 七牛文件路径或完整地址
 * @returns {string} 可直接用于 img/src 的地址
 */
function buildPetImageUrl (imagePath) {
  const path = normalizeString(imagePath)
  if (!path) return ''
  if (/^https?:\/\//i.test(path)) return path
  if (!QINIU_BASE_URL) return path
  return QINIU_BASE_URL + path.replace(/^\/+/, '')
}

function getSpeciesByKey (list, petKey) {
  const key = normalizeString(petKey)
  if (!key) return null
  const options = Array.isArray(list) ? list : []
  for (let i = 0; i < options.length; i++) {
    const item = options[i]
    const itemKey = normalizeString(item && (item.key || item.assetKey))
    if (itemKey === key) return item
  }
  return null
}

function readStateMap () {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    const parsed = raw ? JSON.parse(raw) : {}
    return parsed && typeof parsed === 'object' ? parsed : {}
  } catch (e) {
    return {}
  }
}

function writeStateMap (data) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data || {}))
  } catch (e) {}
}

function normalizeNumber (value, fallback) {
  const num = Number(value)
  return Number.isNaN(num) ? fallback : num
}

function normalizeString (value, fallback) {
  const s = value == null ? '' : String(value)
  return s || (fallback == null ? '' : String(fallback))
}

function getPetAssetBySpeciesIdFromMap (map, speciesId) {
  if (!map || typeof map !== 'object') return null
  const id = speciesId === 0 ? 0 : Number(speciesId)
  if ((!id && id !== 0) || Number.isNaN(id)) return null
  return map[id] || null
}

export default {
  name: 'education-pet-score',
  components: {
    ...common
  },
  data () {
    return {
      loading: false,
      classLoading: false,
      speciesLoading: false,
      classOptions: [],
      currentClassId: '',
      studentList: [],
      speciesOptions: [],
      speciesIdMap: {},
      keyword: '',
      mode: 'single',
      selectedStudentId: '',
      selectedStudentIds: [],
      activeActionCode: ACTION_LIST[0].code,
      actionList: ACTION_LIST,
      stateMap: readStateMap()
    }
  },
  computed: {
    displayStudents () {
      const keyword = String(this.keyword || '').trim().toLowerCase()
      const list = Array.isArray(this.studentList) ? this.studentList : []
      if (!keyword) return list
      return list.filter(item => {
        const name = String(item.studentName || '').toLowerCase()
        return name.indexOf(keyword) > -1
      })
    },
    currentAction () {
      const code = this.activeActionCode
      const list = Array.isArray(this.actionList) ? this.actionList : []
      return list.find(item => item.code === code) || list[0] || null
    },
    activeStudent () {
      const id = String(this.selectedStudentId || '')
      const list = Array.isArray(this.studentList) ? this.studentList : []
      return list.find(item => String(item.studentId) === id) || null
    },
    batchStudents () {
      const ids = this.selectedStudentIds.map(item => String(item))
      const list = Array.isArray(this.studentList) ? this.studentList : []
      return list.filter(item => ids.indexOf(String(item.studentId)) > -1)
    },
    currentTargetIds () {
      if (this.mode === 'batch') {
        return this.selectedStudentIds.map(item => String(item))
      }
      return this.selectedStudentId ? [String(this.selectedStudentId)] : []
    },
    currentTargetText () {
      if (this.mode === 'batch') {
        const count = this.selectedStudentIds.length
        return count > 0 ? ('已选择 ' + count + ' 位孩子') : '请选择需要批量操作的孩子'
      }
      return this.activeStudent ? this.activeStudent.studentName : '请选择一位孩子'
    }
  },
  methods: {
    loadClasses () {
      this.classLoading = true
      ApiClassManagement.getClassList.call(this, {
        studyClassCondition: 'CLASS_MANAGEMENT',
        studyClassType: 'HOSTING'
      }, res => {
        const list = Array.isArray(res) ? res : []
        this.classOptions = list.map(item => ({
          studyClassId: item && item.studyClass
            ? item.studyClass.studyClassId
            : item.studyClassId,
          studyClassName: item && item.studyClass
            ? item.studyClass.studyClassName
            : item.studyClassName
        }))
        this.classLoading = false
        if (!this.classOptions.length) {
          this.currentClassId = ''
          this.studentList = []
          return
        }
        if (!this.currentClassId) {
          this.currentClassId = this.classOptions[0].studyClassId
        }
        this.loadStudents()
      }, () => {
        this.classLoading = false
      })
    },
    buildSpeciesIdMap (options) {
      const list = Array.isArray(options) ? options : []
      const map = {}
      list.forEach(item => {
        if (!item) return
        const id = item.speciesId === 0 ? 0 : Number(item.speciesId)
        if ((!id && id !== 0) || Number.isNaN(id)) return
        map[id] = {
          speciesId: id,
          key: normalizeString(item.key || item.assetKey),
          name: normalizeString(item.name, ('物种' + id)),
          image: item.image || '',
          mainImage: normalizeString(item.mainImage),
          assetKey: normalizeString(item.assetKey),
          enabled: item && item.enabled !== false
        }
      })
      return map
    },
    loadSpecies () {
      this.speciesLoading = true
      const self = this
      ApiStudentManagement.listSpecies.call(this, { enabled: true }, res => {
        const list = Array.isArray(res) ? res : []
        const enabled = list.filter(item => item && item.enabled !== false)
        self.speciesOptions = enabled.map(item => {
          const speciesId = Number(item.speciesId)
          const assetKey = item && item.assetKey ? String(item.assetKey) : ''
          const mainImage = item && item.mainImage ? String(item.mainImage) : ''
          const serverName = item && item.name ? String(item.name) : ''
          return {
            speciesId: speciesId,
            key: assetKey,
            name: serverName || assetKey || '',
            image: buildPetImageUrl(mainImage),
            mainImage: mainImage,
            assetKey: assetKey,
            enabled: item && item.enabled !== false
          }
        }).filter(item => item && item.speciesId && !Number.isNaN(item.speciesId))
        self.speciesIdMap = self.buildSpeciesIdMap(self.speciesOptions)
        if (self.studentList && self.studentList.length) {
          self.studentList = self.studentList.map(s => self.decorateStudent(s.raw || s))
        }
        self.speciesLoading = false
      }, () => {
        self.speciesOptions = []
        self.speciesIdMap = {}
        if (self.studentList && self.studentList.length) {
          self.studentList = self.studentList.map(s => self.decorateStudent(s.raw || s))
        }
        self.speciesLoading = false
      })
    },
    loadStudents () {
      if (!this.currentClassId) {
        this.studentList = []
        return
      }
      this.loading = true
      const keyword = String(this.keyword || '').trim()
      const data = {
        studyClassId: this.currentClassId,
        studentName: keyword
      }
      ApiStudentManagement.getClassOverview.call(this, data, res => {
        const list = res && Array.isArray(res) ? res : []
        this.studentList = list.map(item => this.decorateStudent(item))
        this.resetSelectionAfterLoad()
        this.loading = false
      }, () => {
        this.loading = false
      })
    },
    decorateStudent (row) {
      const item = row || {}
      const rawStudent = item.student && typeof item.student === 'object'
        ? item.student
        : {}
      const rawPet = item.pet && typeof item.pet === 'object'
        ? item.pet
        : null
      const rawAccount = item.account && typeof item.account === 'object'
        ? item.account
        : {}
      const studentId = item.studentId
        ? String(item.studentId)
        : (rawStudent.studentId ? String(rawStudent.studentId) : '')
      const studentName = normalizeString(rawStudent.studentName, '')
      const gradeInfo = rawStudent.grade && typeof rawStudent.grade === 'object'
        ? rawStudent.grade
        : null
      const gradeName = gradeInfo ? normalizeString(gradeInfo.i18nName, '') : ''
      const gradeCode = gradeInfo && gradeInfo.code != null ? Number(gradeInfo.code) : null
      const genderRaw = rawStudent.gender
      const gender = genderRaw === true
        ? 'male'
        : (genderRaw === false ? 'female' : '')
      const genderText = gender === 'male' ? '男' : (gender === 'female' ? '女' : '')
      const services = normalizeString(rawStudent.services, '')
      const serviceList = services
        ? services.split(',').map(s => normalizeString(s)).filter(Boolean)
        : []
      const statusRaw = normalizeString(item.status, '')
      const isClaimed = statusRaw === 'CLAIMED'

      const petId = rawPet && rawPet.petId != null ? String(rawPet.petId) : ''
      const speciesId = rawPet && rawPet.speciesId != null ? Number(rawPet.speciesId) : null
      const level = rawPet && rawPet.level != null ? Number(rawPet.level) : 0
      const nickname = rawPet ? normalizeString(rawPet.nickname, '') : ''
      const claimTime = rawPet && rawPet.claimTime ? Number(rawPet.claimTime) : 0

      const todayScore = normalizeNumber(rawAccount.todayScore, 0)
      const totalScore = normalizeNumber(rawAccount.totalScore, 0)
      const availableScore = normalizeNumber(rawAccount.availableScore, 0)

      const state = this.getStudentState(studentId)

      let petOption = null
      if (speciesId) {
        petOption = getPetAssetBySpeciesIdFromMap(this.speciesIdMap, speciesId)
      }
      if (!petOption && state.petKey) {
        petOption = this.getPetInfo(state.petKey)
      }
      const petKey = petOption ? normalizeString(petOption.key) : ''

      const localDelta = normalizeNumber(state.deltaScore, 0)
      const mergedAvailable = availableScore + localDelta
      const mergedTotal = totalScore + localDelta

      return {
        raw: item,
        studentId: studentId,
        studentName: studentName,
        gradeName: gradeName,
        gradeCode: gradeCode,
        gender: gender,
        genderText: genderText,
        services: services,
        serviceList: serviceList,
        status: statusRaw,
        isClaimed: isClaimed,
        pet: {
          petId: petId,
          speciesId: speciesId,
          level: level,
          nickname: nickname,
          claimTime: claimTime,
          petKey: petKey
        },
        scores: {
          todayScore: todayScore,
          totalScore: totalScore,
          availableScore: availableScore,
          localDelta: localDelta,
          mergedAvailable: mergedAvailable,
          mergedTotal: mergedTotal
        }
      }
    },
    getStudentState (studentId) {
      const key = String(studentId || '')
      const map = this.stateMap && typeof this.stateMap === 'object'
        ? this.stateMap
        : {}
      const current = map[key]
      if (current && typeof current === 'object') {
        return {
          deltaScore: normalizeNumber(current.deltaScore, 0),
          petKey: normalizeString(current.petKey, '')
        }
      }
      return {
        deltaScore: 0,
        petKey: ''
      }
    },
    persistStudentState (studentIds, updater) {
      const ids = Array.isArray(studentIds) ? studentIds : []
      if (!ids.length || typeof updater !== 'function') return
      const nextMap = Object.assign({}, this.stateMap || {})
      ids.forEach(id => {
        const key = String(id)
        const current = this.getStudentState(key)
        const next = updater(Object.assign({}, current), key) || current
        nextMap[key] = {
          deltaScore: normalizeNumber(next.deltaScore, 0),
          petKey: normalizeString(next.petKey, '')
        }
      })
      this.stateMap = nextMap
      writeStateMap(nextMap)
      this.studentList = this.studentList.map(item => {
        const key = String(item.studentId)
        if (ids.indexOf(key) < 0) return item
        const state = this.getStudentState(key)
        const nextPetKey = state.petKey
        const nextDelta = state.deltaScore
        const speciesId = item.pet && item.pet.speciesId != null
          ? Number(item.pet.speciesId)
          : null
        let petOption = null
        if (speciesId && !nextPetKey) {
          petOption = getPetAssetBySpeciesIdFromMap(this.speciesIdMap, speciesId)
        }
        if (!petOption && nextPetKey) {
          petOption = this.getPetInfo(nextPetKey)
        }
        const availableScore = item.scores
          ? normalizeNumber(item.scores.availableScore, 0)
          : 0
        const totalScore = item.scores
          ? normalizeNumber(item.scores.totalScore, 0)
          : 0
        const petKey = petOption ? normalizeString(petOption.key) : ''
        return Object.assign({}, item, {
          pet: Object.assign({}, item.pet || {}, {
            petKey: petKey
          }),
          scores: Object.assign({}, item.scores || {}, {
            localDelta: nextDelta,
            mergedAvailable: availableScore + nextDelta,
            mergedTotal: totalScore + nextDelta
          })
        })
      })
    },
    resetSelectionAfterLoad () {
      const ids = this.studentList.map(item => String(item.studentId))
      this.selectedStudentIds = this.selectedStudentIds.filter(id => {
        return ids.indexOf(String(id)) > -1
      })
      if (this.mode === 'single') {
        if (ids.indexOf(String(this.selectedStudentId)) < 0) {
          this.selectedStudentId = ids[0] || ''
        }
      } else if (this.selectedStudentId && ids.indexOf(String(this.selectedStudentId)) < 0) {
        this.selectedStudentId = ''
      }
    },
    onClassChange () {
      this.keyword = ''
      this.selectedStudentId = ''
      this.selectedStudentIds = []
      this.loadStudents()
    },
    onSearch () {
      this.loadStudents()
    },
    onModeChange (mode) {
      this.mode = mode
      if (mode === 'single') {
        if (!this.selectedStudentId && this.displayStudents.length) {
          this.selectedStudentId = this.displayStudents[0].studentId
        }
      }
    },
    isSelected (student) {
      const id = String(student && student.studentId ? student.studentId : '')
      if (!id) return false
      if (this.mode === 'batch') {
        return this.selectedStudentIds.indexOf(id) > -1
      }
      return String(this.selectedStudentId) === id
    },
    onStudentSelect (student) {
      if (!student || !student.studentId) return
      const id = String(student.studentId)
      if (this.mode === 'batch') {
        const index = this.selectedStudentIds.indexOf(id)
        if (index > -1) {
          this.selectedStudentIds.splice(index, 1)
        } else {
          this.selectedStudentIds.push(id)
        }
        return
      }
      this.selectedStudentId = id
    },
    clearBatchSelection () {
      this.selectedStudentIds = []
    },
    selectAction (action) {
      if (!action || !action.code) return
      this.activeActionCode = action.code
    },
    buildGrantScorePayload (action, ids) {
      const studyClassId = this.currentClassId ? Number(this.currentClassId) : null
      const score = normalizeNumber(action && action.points, 0)
      const payload = {
        studyClassId: studyClassId,
        score: score,
        sourceType: 'ZONE',
        reasonCode: action && action.code ? String(action.code) : '',
        reasonText: action && action.name ? String(action.name) : '',
        remark: ''
      }
      const idList = Array.isArray(ids) ? ids.filter(Boolean) : []
      if (this.mode === 'single' && idList.length) {
        payload.studentId = Number(idList[0])
        payload.studentIds = null
      } else if (idList.length) {
        payload.studentId = null
        payload.studentIds = idList.map(item => Number(item))
      } else {
        payload.studentId = null
        payload.studentIds = null
      }
      return payload
    },
    showBatchResults (results, actionName, actionVerb) {
      const list = Array.isArray(results) ? results : []
      const verb = actionVerb && String(actionVerb) ? String(actionVerb) : '更新'
      const successItems = list.filter(item => item && item.success)
      const failItems = list.filter(item => item && !item.success)
      if (successItems.length && successItems.length === list.length) {
        const tip = this.mode === 'batch'
          ? ('已为 ' + successItems.length + ' 位孩子完成「' + actionName + '」' + verb)
          : ('已为 ' + this.currentTargetText + ' 完成「' + actionName + '」' + verb)
        this.$message({ message: tip, type: 'success' })
        return
      }
      if (!successItems.length && failItems.length) {
        const reasons = failItems.map((item, idx) => {
          const no = idx + 1
          const msg = item && item.errorMessage ? String(item.errorMessage) : '未知原因'
          return no + '. ' + msg
        }).join('；')
        this.$message({
          message: '本次「' + actionName + '」' + verb + '全部失败：' + reasons,
          type: 'error'
        })
        return
      }
      if (successItems.length && failItems.length) {
        const failTip = failItems.map(item => {
          const sid = item && item.studentId != null ? String(item.studentId) : '-'
          const student = this.studentList.find(s => String(s.studentId) === sid)
          const name = student && student.studentName ? student.studentName : ('学生' + sid)
          const msg = item && item.errorMessage ? String(item.errorMessage) : '失败'
          return name + '：' + msg
        }).join('；')
        this.$message({
          message: '「' + actionName + '」' + verb + '部分成功（成功 ' +
            successItems.length + '/' + list.length +
            '），失败明细：' + failTip,
          type: 'warning'
        })
      }
    },
    showGrantScoreResults (results, actionName) {
      this.showBatchResults(results, actionName, '加分')
    },
    buildAssignPetPayload (petOption, ids) {
      const speciesId = petOption && petOption.speciesId != null
        ? Number(petOption.speciesId)
        : null
      const studyClassId = this.currentClassId ? Number(this.currentClassId) : null
      const payload = {
        speciesId: speciesId,
        nickname: null,
        studyClassId: studyClassId
      }
      const idList = Array.isArray(ids) ? ids.filter(Boolean) : []
      if (this.mode === 'single' && idList.length) {
        payload.studentId = Number(idList[0])
        payload.studentIds = null
      } else if (idList.length) {
        payload.studentId = null
        payload.studentIds = idList.map(item => Number(item))
      } else {
        payload.studentId = null
        payload.studentIds = null
      }
      return payload
    },
    showAssignPetResults (results, petName) {
      this.showBatchResults(results, petName || '宠物', '分配')
    },
    confirmAction () {
      const self = this
      const action = this.currentAction
      const ids = this.currentTargetIds
      if (!action || !ids.length) {
        this.$message({
          message: this.mode === 'batch' ? '请先选择孩子' : '请先选择一位孩子',
          type: 'warning'
        })
        return
      }
      const score = normalizeNumber(action.points, 0)
      if (!(score > 0)) {
        this.$message({
          message: '当前动作分数不合法，只能选择正整数加分',
          type: 'warning'
        })
        return
      }
      const payload = this.buildGrantScorePayload(action, ids)
      this.loading = true
      ApiStudentManagement.grantScore.call(this, payload, res => {
        const results = res && Array.isArray(res.results) ? res.results : []
        const actionName = action && action.name ? action.name : '积分'
        const successIds = results
          .filter(item => item && item.success && item.studentId != null)
          .map(item => String(item.studentId))
        if (successIds.length) {
          self.persistStudentState(successIds, state => {
            state.deltaScore = 0
            return state
          })
        }
        self.showGrantScoreResults(results, actionName)
        self.loadStudents()
      }, () => {
        self.loading = false
        self.$message({
          message: '加分请求失败，请稍后重试',
          type: 'error'
        })
      })
    },
    selectPet (pet) {
      const self = this
      const ids = this.currentTargetIds
      if (!ids.length) {
        this.$message({
          message: this.mode === 'batch' ? '请先选择孩子' : '请先选择一位孩子',
          type: 'warning'
        })
        return
      }
      if (!pet) {
        this.persistStudentState(ids, state => {
          state.petKey = ''
          return state
        })
        this.$message({
          message: '已清空本地宠物选择（再次进入页面以服务端为准）',
          type: 'info'
        })
        return
      }
      const speciesId = pet && pet.speciesId != null ? Number(pet.speciesId) : null
      if (!speciesId || Number.isNaN(speciesId) || speciesId <= 0) {
        this.$message({
          message: '当前宠物缺少有效的物种 ID，无法分配',
          type: 'warning'
        })
        return
      }
      const payload = this.buildAssignPetPayload(pet, ids)
      const petName = pet && pet.name ? String(pet.name) : '宠物'
      this.loading = true
      ApiStudentManagement.assignPet.call(this, payload, res => {
        const results = res && Array.isArray(res.results) ? res.results : []
        const successIds = results
          .filter(item => item && item.success && item.studentId != null)
          .map(item => String(item.studentId))
        if (successIds.length) {
          self.persistStudentState(successIds, state => {
            state.petKey = pet && pet.key ? pet.key : ''
            return state
          })
        }
        self.showAssignPetResults(results, petName)
        self.loadStudents()
      }, () => {
        self.loading = false
        self.$message({
          message: '宠物分配请求失败，请稍后重试',
          type: 'error'
        })
      })
    },
    getPetInfoBySpecies (speciesId) {
      return getPetAssetBySpeciesIdFromMap(this.speciesIdMap, speciesId)
    },
    getPetInfo (petKey) {
      const key = normalizeString(petKey)
      if (!key) return null
      const speciesItem = getSpeciesByKey(this.speciesOptions, key)
      if (!speciesItem) return null
      return {
        key: key,
        name: (speciesItem && speciesItem.name)
          ? String(speciesItem.name)
          : key,
        image: (speciesItem && speciesItem.image)
          ? String(speciesItem.image)
          : '',
        speciesId: speciesItem && speciesItem.speciesId != null
          ? Number(speciesItem.speciesId)
          : null,
        assetKey: (speciesItem && speciesItem.assetKey)
          ? String(speciesItem.assetKey)
          : key
      }
    },
    getPetImage (petKey) {
      if (!petKey) return ''
      const direct = this.getPetInfo(petKey)
      if (direct && direct.image) return direct.image
      return ''
    },
    getPetName (petKey) {
      if (!petKey) return '未选择宠物'
      const direct = this.getPetInfo(petKey)
      if (direct && direct.name) return direct.name
      return '未选择宠物'
    },
    formatPoints (points) {
      const value = normalizeNumber(points, 0)
      return value > 0 ? ('+' + value) : String(value)
    }
  },
  mounted () {
    this.loadSpecies()
    this.loadClasses()
  }
}
